import React, { useState } from 'react';
import moment from 'moment';
import CollapsiblePanel from '../../../../formInputsV2/CollapsiblePanel';
import { Card, AlwaysOpenAtDesktop } from './shared.styles';
import {
  Header, Title, ModificaButton, CompactSummary, InfoList, InfoRow,
} from './VehicleSummaryCard.styles';
import editIcon from '../../../../../assets/redesign_icons/edit-icon.svg';

function SanitariaStranieriSummaryCard({ customer, insuranceRequest, modifyData }) {
  const [detailsOpen, setDetailsOpen] = useState(false);

  const provenienza = insuranceRequest.sanitaria_stranieri.europe_world === 'europe' ? 'Europe' : 'Mondo';
  const giaPresente = insuranceRequest.sanitaria_stranieri.is_resident === 1 ? 'Si' : 'No';

  return (
    <Card>
      <Header>
        <Title>Sanitaria Per Stranieri</Title>
        {modifyData && (
          <ModificaButton type="button" onClick={() => modifyData()}>
            Modifica Dati
            <img src={editIcon} alt="" />
          </ModificaButton>
        )}
      </Header>

      <CompactSummary>
        {customer.name}
        {' '}
        {customer.surname}
      </CompactSummary>

      <AlwaysOpenAtDesktop>
        <CollapsiblePanel
          open={detailsOpen}
          onToggle={() => setDetailsOpen((open) => !open)}
          instructionText=""
          openLabel="Nascondi dettagli"
          closedLabel="Dettagli"
        >
          <InfoList>
            <InfoRow>
              <dt>Contraente</dt>
              <dd>
                {customer.name}
                {' '}
                {customer.surname}
              </dd>
            </InfoRow>
            <InfoRow>
              <dt>Provenienza</dt>
              <dd>{provenienza}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Durata in Giorni</dt>
              <dd>{insuranceRequest.sanitaria_stranieri.days_of_staying}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Già Presente in Italia</dt>
              <dd>{giaPresente}</dd>
            </InfoRow>
            <InfoRow>
              <dt>Inizio Copertura</dt>
              <dd>{moment(insuranceRequest.policy_effective_date).format('DD-MM-YYYY')}</dd>
            </InfoRow>
          </InfoList>
        </CollapsiblePanel>
      </AlwaysOpenAtDesktop>
    </Card>
  );
}

export default SanitariaStranieriSummaryCard;
